var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{on:{"keydown":_vm.onKeyDown}},[_c('v-combobox',{ref:"field",attrs:{"search":_vm.search,"items":_vm.items,"hide-details":"","single-line":"","flat":"","solo":""},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }